module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-slides-cb81bd3e.svg";